// Клієнтська матриця прав (SPEC розд. 5) — ЛИШЕ для приховування елементів інтерфейсу.
// Справжня перевірка — на сервері (AccessService: scopeWhere / assertCan). Область (свій факультет / своя кафедра)
// тут не перевіряється: сервер відфільтрує списки й відхилить дію з 403.
import { Role } from '@unisched/shared';

const STAFF: readonly Role[] = [Role.SYSADMIN, Role.SCHEDULE_ADMIN, Role.ACADEMIC_OFFICE, Role.FACULTY, Role.DEPARTMENT];
const ADMINS: readonly Role[] = [Role.SYSADMIN, Role.SCHEDULE_ADMIN];
const OFFICE: readonly Role[] = [Role.SYSADMIN, Role.SCHEDULE_ADMIN, Role.ACADEMIC_OFFICE];

export const PERMISSIONS = {
  /** Користувачі й ролі */
  'users.manage': [Role.SYSADMIN],
  /** Перегляд довідників */
  'directories.view': STAFF,
  /** Структурні довідники, класифікатори */
  'directories.edit': ADMINS,
  /** Правила розкладу, профілі ваг */
  'rules.edit': ADMINS,
  /** Групи, потоки, підгрупи, студенти (FACULTY — свого факультету) */
  'contingent.edit': [...OFFICE, Role.FACULTY],
  /** Викладачі (DEPARTMENT — своєї кафедри) */
  'teachers.edit': [...OFFICE, Role.DEPARTMENT],
  /** Перегляд навантаження */
  'workload.view': STAFF,
  /** Навантаження (DEPARTMENT — своєї кафедри) */
  'workload.edit': [...OFFICE, Role.DEPARTMENT],
  /** Доступність викладача (TEACHER — власна) */
  'availability.edit': [...OFFICE, Role.DEPARTMENT, Role.TEACHER],
  /** Перевірка даних перед генерацією */
  'validation.view': STAFF,
  /** Запуск генерації (FACULTY — область факультету) */
  'generation.run': [...OFFICE, Role.FACULTY],
  /** Перегляд усіх розкладів і чернеток */
  'schedule.viewAll': STAFF,
  /** Ручне редагування DRAFT / RETURNED */
  'schedule.edit': STAFF,
  /** Конфлікти */
  'conflicts.view': STAFF,
  /** Версії й погодження */
  'versions.view': STAFF,
  /** Рішення на кроці погодження */
  'approval.decide': [Role.ACADEMIC_OFFICE, Role.FACULTY, Role.DEPARTMENT],
  /** Публікація */
  'schedule.publish': OFFICE,
  /** Аналітика */
  'analytics.view': STAFF,
  /** Журнал аудиту */
  'audit.view': OFFICE,
  /** «Мій розклад» */
  'mySchedule.view': [Role.TEACHER, Role.STUDENT],
} as const satisfies Record<string, readonly Role[]>;

export type Permission = keyof typeof PERMISSIONS;

/** Чи дозволяє хоч одна з ролей дію (без перевірки області). */
export function rolesCan(roles: readonly Role[], permission: Permission): boolean {
  const allowed: readonly Role[] = PERMISSIONS[permission];
  return roles.some((r) => allowed.includes(r));
}
